import { FC } from "react";
import styles from "./skins.module.css";
import { SkinsShopWidget } from "@widgets/ShopSkinsWidget";
import { useNavigate } from "@tanstack/react-router";

export const SkinsShop: FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate({ to: "/shop/select-game" });
  };
  return (
    <div className={styles.container}>
      <div className={styles.ArchiveContainer}>
        <div className={styles.topHeader}>
          <button className={styles.backToGames} onClick={handleBack}>
            <svg
              width="10"
              height="16"
              viewBox="0 0 10 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.14545 15.6818C8.5697 16.1061 9.25755 16.1061 9.68181 15.6818C10.1061 15.2576 10.1061 14.5697 9.68181 14.1454L3.53636 8L9.68181 1.85455C10.1061 1.4303 10.1061 0.742446 9.68181 0.318191C9.25755 -0.106064 8.5697 -0.106063 8.14545 0.318191L2 6.46364L0.463639 8L2 9.53636L8.14545 15.6818Z"
                fill="white"
              />
            </svg>
            BACK TO GAMES
          </button>
          <div className={styles.archiveTitle}>ARCHIVE</div>
        </div>
        <div className={styles.gridContainer}>
          <SkinsShopWidget />
        </div>
        <div className={styles.footerTop}>
          <div className={styles.footerTop__text}>
          <span className={styles.h11}>SKINS ROTATION & PIN</span>
            <span className={styles.p}>
              Список скинов обновляется каждые 24 часа. Что видишь — твой
              уникальный выбор. Скины могут закончиться — не тупи. У VIP-игроков
              есть кнопка PIN — закрепи скин, чтобы не потерять. Снял PIN и скин
              пропал? Сам виноват.
            </span>
          </div>
          <button
            className={styles.archive}
            onClick={() => navigate({ to: "/shop/select-game/top-skins" })}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.1454 15.6818C14.5697 16.1061 15.2576 16.1061 15.6818 15.6818C16.1061 15.2576 16.1061 14.5697 15.6818 14.1454L9.53636 8L15.6818 1.85455C16.1061 1.4303 16.1061 0.742446 15.6818 0.318191C15.2576 -0.106064 14.5697 -0.106063 14.1454 0.318191L8 6.46364L1.85455 0.318191C1.4303 -0.106064 0.742446 -0.106064 0.318191 0.318191C-0.106064 0.742446 -0.106063 1.4303 0.318191 1.85455L6.46364 8L0.318191 14.1454C-0.106064 14.5697 -0.106064 15.2576 0.318191 15.6818C0.742446 16.1061 1.4303 16.1061 1.85455 15.6818L8 9.53636L14.1454 15.6818Z"
                fill="white"
              />
            </svg>
            CLOSE
          </button>
        </div>
      </div>
    </div>
  );
};
